// routes.ts
import AddHolidays from "../pages/master-data/holidays/add-holiday/AddHolidays";
import Holidays from "../pages/master-data/holidays/holidays-list/Holidays";
import HolidaysTable from "../pages/master-data/holidays/holidays-list/HolidaysTable";
import HolidaysYears from "../pages/master-data/holidays/holidays-list/HolidaysYears";
import ImportHoliday from "../pages/master-data/holidays/import-holiday/ImportHoliday";
import HolidayType from "../pages/master-data/holiday-type/HolidayType";
import ImportHolidayType from "../pages/master-data/holiday-type/ImportHolidayType";
import ImportLeaveType from "../pages/master-data/leave-type/ImportLeaveType";   
import LeaveType from "../pages/master-data/leave-type/LeaveType";
import AddOrganization from "../pages/master-data/organization/add-organization/AddOrganization";
import Organization from "../pages/master-data/organization/Organization";
import ViewOrganization from "../pages/master-data/organization/view-organization/ViewOrganization";
import AddTaxType from "../pages/master-data/tax-types/addtax-type/AddTaxType";
import TaxListCountry from "../pages/master-data/tax-types/tax-list/TaxListCountry";
import TaxListCountryHistory from "../pages/master-data/tax-types/tax-list/TaxListCountryHistory";
import TaxType from "../pages/master-data/tax-types/tax-list/TaxType";
import IPSettings from "../pages/master-settings/ip-settings/IPSettings";
import ProfileAccount from "../pages/profile/ProfileAccount";
import ErrorLogReport from "../pages/reports/ErrorLogReport";
import ErrorlogView from "../pages/reports/ErrorlogView";
import LastLoginReport from "../pages/reports/LastLoginReport";
import LoginFailuresReport from "../pages/reports/LoginFailuresReport";
import Reports from "../pages/reports/Reports";
import UserActivityReport from "../pages/reports/UserActivityReport";
import SamplePage from "../pages/sample-page/SamplePage";
import SMSGateway from "../pages/master-settings/sms-gateway/SMSGateway";
import ViewSmsGateway from "../pages/master-settings/sms-gateway/ViewSmsGateway";
import PaymentGateway from "../pages/master-settings/payment-gateway/PaymentGateway";
import ViewPayment from "../pages/master-settings/payment-gateway/ViewPayment";
import OrganizationTrends from "../pages/reports/OrganizationTrends";
import UserTrends from "../pages/reports/UserTrends";
import EditSmsDetails from "../pages/master-settings/sms-gateway/edit-sms-details/EditSmsDetails";
import OrganizationAdmin from "../pages/users/organization-admin/OrganizationAdmin";
import EditUserList from "../pages/users/organization-admin/edit-user-list/EditUserList";
import ViewOrganizationAdmin from "../pages/users/view-organization-admin/ViewOrganizationAdmin";
import ActivityLogs from "../pages/users/activity-logs/ActivityLogs";
import AccessRights from "../pages/users/user-acess-rights/AccessRights";
import UserList from "../pages/users/UserList";
import AddUser from "../pages/users/AddUser";
import ViewUser from "../pages/users/ViewUser";
import EditUser from "../pages/users/EditUser";
import UserActivityLogs from "../pages/users/UserActivityLogs";
import UserAccessRights from "../pages/users/UserAccessRights";
import EditProfile from "../pages/profile/EditProfile";
import GeneralSettings from "../pages/master-settings/general-settings/GeneralSettings";
import EditPayment from "../pages/master-settings/payment-gateway/EditPayment";
import AddUserSales from "../pages/users/sales/AddUserSales";
import AddDevelopers from "../pages/users/developers/AddDevelopers";
import AddUserSupport from "../pages/users/support/AddUserSupport";
import Sales from "../pages/users/sales/Sales";
import ViewSalesUser from "../pages/users/sales/ViewSalesUser";
import EditUserSales from "../pages/users/sales/EditUserSales";
import ActivityLogsUserSales from "../pages/users/sales/ActivityLogsUserSales";
import AccessRightsUserSales from "../pages/users/sales/AccessRightsUserSales";
import Developers from "../pages/users/developers/Developers";
import ViewDeveloperUser from "../pages/users/developers/ViewDeveloperUser";
import EditUserDeveloper from "../pages/users/developers/EditUserDeveloper";
import ActivityLogsUserDeveloper from "../pages/users/developers/ActivityLogsUserDeveloper";
import AccessRightsUserDeveloper from "../pages/users/developers/AccessRightsUserDeveloper";
import Support from "../pages/users/support/Support";
import ViewSupportUser from "../pages/users/support/ViewSupportUser";
import EditUserSupport from "../pages/users/support/EditUserSupport";
import ActivityLogsUserSupport from "../pages/users/support/ActivityLogsUserSupport";
import AccessRightsUserSupport from "../pages/users/support/AccessRightsUserSupport";
import EmailCommunication from "../pages/communication/email/EmailCommunication";
import SMSCommunication from "../pages/communication/sms/SMSCommunication";
import ComposeEmailPage from "../pages/communication/email/compose-email-modal/ComposeEmail";
import EmailDetail from "../pages/communication/email/email-detail/EmailDetail";
import ComposeSMSPage from "../pages/communication/sms/sms-right-side/ComposeSMSPage";
import PushNotificationCommunication from "../pages/communication/push-notification/PushNotificationCommunication";
import ComposePushNotificationPage from "../pages/communication/push-notification/push-notification-right-side/ComposePushNotificationPage";
import ApiKeys from "../pages/master-data/organization/ApiKeys";
import AppVersionReports from "../pages/reports/AppVersionReports";
import RecieptList from "../pages/billing-payments/receipt/RecieptList";
import ViewReciept from "../pages/billing-payments/receipt/ViewReciept";
import Dashboard from "../pages/dashboard/Dashboard";
import AddAddons from "../component/addons/add-addons/AddAddons";
import ViewAllNotification from "../component/notification/ViewAllNotification";
import SMSDetail from "../pages/communication/sms/sms-right-side/SMSDetail";
import PushNotificationDetail from "../pages/communication/push-notification/push-notification-right-side/PushNotificationDetail";
import Addons from "../pages/addons/Addons";
import Invoice from "../pages/billing-payments/invoice/Invoice";
import AddInvoice from "../pages/billing-payments/invoice/AddInvoice";
import ViewInvoice from "../pages/billing-payments/invoice/ViewInvoice";

export const routes = [
  // Dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Dashboard /> },

  // Sample Page
  {
    path: `${process.env.PUBLIC_URL}/pages/samplepage`,
    Component: <SamplePage />,
  },

  // Notification
  {
    path: `${process.env.PUBLIC_URL}/notification`,
    Component: <ViewAllNotification />,
  },

  // Profile
  {
    path: `${process.env.PUBLIC_URL}/profile/account`,
    Component: <ProfileAccount />,
  },
  {
    path: `${process.env.PUBLIC_URL}/profile/edit-profile`,
    Component: <EditProfile />,
  },

  // Master Data - Organization
  {
    path: `${process.env.PUBLIC_URL}/masterdata/organization`,
    Component: <Organization />,
  },
  {
    path: `${process.env.PUBLIC_URL}/organization/add`,
    Component: <AddOrganization />,
  },
  {
    path: `${process.env.PUBLIC_URL}/organization/edit/:id`,
    Component: <AddOrganization />,
  },
  {
    path: `${process.env.PUBLIC_URL}/organization/view/:id`,
    Component: <ViewOrganization />,
  },

  // Master Data - Holidays
  {
    path: `${process.env.PUBLIC_URL}/masterdata/holidays`,
    Component: <Holidays />,
  },
  {
    path: `${process.env.PUBLIC_URL}/masterdata/new-holiday`,
    Component: <AddHolidays />,
  },
  {
    path: `${process.env.PUBLIC_URL}/masterdata/import-holiday`,
    Component: <ImportHoliday />,
  },
  {
    path: `${process.env.PUBLIC_URL}/holidays/country/:countryName`,
    Component: <HolidaysYears />,
  },
  {
    path: `${process.env.PUBLIC_URL}/holidays/country/:countryName/:year`,
    Component: <HolidaysTable />,
  },

  // Master Data - Holiday Type
  {
    path: `${process.env.PUBLIC_URL}/masterdata/holiday-type`,
    Component: <HolidayType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/masterdata/import-holiday-type`,
    Component: <ImportHolidayType />,
  },

  // Master Data - Leave Type
  {
    path: `${process.env.PUBLIC_URL}/masterdata/leave-type`,
    Component: <LeaveType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/masterdata/import-leave-type`,
    Component: <ImportLeaveType />,
  },

  // Master Data - Tax Types
  {
    path: `${process.env.PUBLIC_URL}/masterdata/taxtype`,
    Component: <TaxType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/masterdata/add-tax-type`,
    Component: <AddTaxType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tax-types/country/:countryName`,
    Component: <TaxListCountry />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tax-types/country/:countryName/history`,
    Component: <TaxListCountryHistory />,
  },

  // Users - Organization Admin
  {
    path: `${process.env.PUBLIC_URL}/users/organization-admin`,
    Component: <OrganizationAdmin />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/organization-admin/new`,
    Component: <EditUserList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/organization-admin/edit/:id`,
    Component: <EditUserList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/organization-admin/view/:id`,
    Component: <ViewOrganizationAdmin />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/organization-admin/activity-logs/:id`,
    Component: <ActivityLogs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/organization-admin/user-access-rights/:id`,
    Component: <AccessRights />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/organization-admin/api-keys`,
    Component: <ApiKeys />,
  },

  // Users - Sales
  { path: `${process.env.PUBLIC_URL}/users/sales`, Component: <Sales /> },
  {
    path: `${process.env.PUBLIC_URL}/users/sales/new`,
    Component: <AddUserSales />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/sales/view/:id`,
    Component: <ViewSalesUser />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/sales/edit/:id`,
    Component: <EditUserSales />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/sales/activity-logs/:id`,
    Component: <ActivityLogsUserSales />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/sales/user-access-rights/:id`,
    Component: <AccessRightsUserSales />,
  },

  // Users - Developers
  {
    path: `${process.env.PUBLIC_URL}/users/developers`,
    Component: <Developers />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/developers/new`,
    Component: <AddDevelopers />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/developers/view/:id`,
    Component: <ViewDeveloperUser />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/developers/edit/:id`,
    Component: <EditUserDeveloper />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/developers/activity-logs/:id`,
    Component: <ActivityLogsUserDeveloper />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/developers/user-access-rights/:id`,
    Component: <AccessRightsUserDeveloper />,
  },

  // Users - Support
  { path: `${process.env.PUBLIC_URL}/users/support`, Component: <Support /> },
  {
    path: `${process.env.PUBLIC_URL}/users/support/new`,
    Component: <AddUserSupport />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/support/view/:id`,
    Component: <ViewSupportUser />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/support/edit/:id`,
    Component: <EditUserSupport />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/support/activity-logs/:id`,
    Component: <ActivityLogsUserSupport />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/support/user-access-rights/:id`,
    Component: <AccessRightsUserSupport />,
  },

  // Users - Dynamic Roles
  { path: `${process.env.PUBLIC_URL}/users/:role`, Component: <UserList /> },
  { path: `${process.env.PUBLIC_URL}/users/:role/new`, Component: <AddUser /> },
  {
    path: `${process.env.PUBLIC_URL}/users/:role/view/:id`,
    Component: <ViewUser />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/:role/edit/:id`,
    Component: <EditUser />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/:role/activity-logs/:id`,
    Component: <UserActivityLogs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/:role/user-access-rights/:id`,
    Component: <UserAccessRights />,
  },

  // Reports
  { path: `${process.env.PUBLIC_URL}/reports`, Component: <Reports /> },
  {
    path: `${process.env.PUBLIC_URL}/reports/user-activity-report`,
    Component: <UserActivityReport />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/organization-trends`,
    Component: <OrganizationTrends />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/user-trends`,
    Component: <UserTrends />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/last-login-report`,
    Component: <LastLoginReport />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/login-failures-report`,
    Component: <LoginFailuresReport />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/error-log-report`,
    Component: <ErrorLogReport />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/view/:id`,
    Component: <ErrorlogView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/app-version-reports`,
    Component: <AppVersionReports />,
  },

  // Master Settings
  {
    path: `${process.env.PUBLIC_URL}/mastersettings/accessrights`,
    Component: <AccessRights />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mastersettings/ipsettings`,
    Component: <IPSettings />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mastersettings/smsgateway`,
    Component: <SMSGateway />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mastersettings/viewsmsgateway/:id`,
    Component: <ViewSmsGateway />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mastersettings/smsgateway/edit/:id`,
    Component: <EditSmsDetails />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mastersettings/paymentgateway`,
    Component: <PaymentGateway />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mastersettings/paymentgateway/view/:id`,
    Component: <ViewPayment />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mastersettings/paymentGateway/edit/:id`,
    Component: <EditPayment />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mastersettings/general-settings`,
    Component: <GeneralSettings />,
  },

  // Communication
  {
    path: `${process.env.PUBLIC_URL}/communication/email`,
    Component: <EmailCommunication />,
  },

  {
    path: `${process.env.PUBLIC_URL}/communication/compose-email`,
    Component: <ComposeEmailPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/communication/email-details`,
    Component: <EmailDetail />,
  },
  {
    path: `${process.env.PUBLIC_URL}/Communication/sms`,
    Component: <SMSCommunication />,
  },
  {
    path: `${process.env.PUBLIC_URL}/communication/compose-sms`,
    Component: <ComposeSMSPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/communication/sms-details`,
    Component: <SMSDetail />,
  },

  {
    path: `${process.env.PUBLIC_URL}/communication/push-notification`,
    Component: <PushNotificationCommunication />,
  },

  {
    path: `${process.env.PUBLIC_URL}/communication/compose-push-notification`,
    Component: <ComposePushNotificationPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/communication/push-notification-details`,
    Component: <PushNotificationDetail />,
  },

  // Addons
  { path: `${process.env.PUBLIC_URL}/addons`, Component: <Addons /> },
  { path: `${process.env.PUBLIC_URL}/addons/add`, Component: <AddAddons /> },
  {
    path: `${process.env.PUBLIC_URL}/addons/edit/:id`,
    Component: <AddAddons />,
  },

  //Billing&payments
  {
    path: `${process.env.PUBLIC_URL}/billingpayments/invoice`,
    Component: <Invoice />,
  },
  {
    path: `${process.env.PUBLIC_URL}/billingpayments/invoice/add`,
    Component: <AddInvoice />,
  },
  {
    path: `${process.env.PUBLIC_URL}/billingpayments/invoice/edit/:id`,
    Component: <AddInvoice />,
  },
  {
    path: `${process.env.PUBLIC_URL}/billingpayments/invoice/view/:id`,
    Component: <ViewInvoice />,
  },
  {
    path: `${process.env.PUBLIC_URL}/billingpayments/reciept`,
    Component: <RecieptList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/billingpayments/reciept/view/:id`,
    Component: <ViewReciept />,
  },
];
